<template>
    <div id="edit_driver_commission_report" class="ui segment">
        <h1 class="ui header">
            <!-- 收派件提成報告 -->
            {{ $t('ui.page_titles.driver_commission_report') }}
        </h1>
        <div v-if="is_initialized">
            <table class="ui very basic celled table">
                <tbody>
                    <tr>
                        <td class="collapsing right aligned">
                            <!-- 人&emsp;&emsp;&emsp;&emsp;&emsp;員 -->
                            {{ $t('models.attributes.driver_commission_reports.staff') }}
                        </td>
                        <td>{{ driver_commission_report.driver_name }}</td>
                    </tr>
                    <tr>
                        <td class="collapsing right aligned">
                            <!-- 期&emsp;&emsp;&emsp;&emsp;&emsp;間 -->
                            {{ $t('models.attributes.driver_commission_reports.time') }}
                        </td>
                        <td>
                            {{ human_datetime(driver_commission_report.begin_at) }}
                            &emsp;{{ $t('ui.pages.driver_commission_reports.to') }}&emsp;
                            {{ human_datetime(driver_commission_report.end_at) }}
                        </td>
                    </tr>
                    <tr>
                        <td class="collapsing right aligned">
                            <!-- 總&emsp;&emsp;金&emsp;&emsp;額 -->
                            {{ $t('ui.pages.driver_commission_reports.total_amount_of_commission') }}
                        </td>
                        <td>{{ driver_commission_report.total_amount }} 元</td>
                    </tr>
                    <tr>
                        <td class="collapsing right aligned">
                            <!-- 產&emsp;生&emsp;日&emsp;期 -->
                            {{ $t('models.attributes.driver_commission_reports.created_at') }}
                        </td>
                        <td>{{ human_datetime(driver_commission_report.created_at) }}</td>
                    </tr>
                </tbody>
            </table>

            <div class="ui equal width grid">
                <div class="column">
                    <h3 class="ui header">
                        <!-- 取件明細 -->
                        {{ $t('ui.pages.driver_commission_reports.table.pickup_details') }}
                    </h3>
                    <table class="ui celled table">
                        <thead>
                            <tr>
                                <th class="collapsing">
                                    <!-- 序號 -->
                                    {{ $t('ui.pages.driver_commission_reports.table.No') }}
                                </th>
                                <th>
                                    <!-- 單號 -->
                                    {{ $t('ui.pages.driver_commission_reports.table.number') }}
                                </th>
                                <th>
                                    <!-- 重量 -->
                                    {{ $t('ui.pages.driver_commission_reports.table.weight') }}
                                </th>
                                <th>
                                    <!-- 日期 -->
                                    {{ $t('ui.pages.driver_commission_reports.table.date') }}
                                </th>
                                <th>
                                    <!-- 提成(元) -->
                                    {{ $t('ui.pages.driver_commission_reports.table.commission') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(commission, index) in driver_commission_report.pick_up_driver_commissions">
                                <td>{{ index+1 }}</td>
                                <td>{{ commission.core_waybill.number }}</td>
                                <td>{{ commission.core_waybill.weight_in_kilo }}</td>
                                <td>{{ human_datetime(commission.created_at) }}</td>
                                <td>{{ commission.amount }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                                <tr>
                                    <th colspan="4" class="center aligned">
                                        {{ $t('ui.pages.driver_commission_reports.table.total') }}
                                    </th>
                                    <th>{{ total_amount(driver_commission_report.pick_up_driver_commissions) }}</th>
                                </tr>
                        </tfoot>
                    </table>
                </div>
                <div class="column">
                    <h3 class="ui header">
                        <!-- 派件明細 -->
                        {{ $t('ui.pages.driver_commission_reports.table.dispatch_details') }}
                    </h3>
                    <table class="ui celled table">
                        <thead>
                            <tr>
                                <th class="collapsing">
                                    <!-- 序號 -->
                                    {{ $t('ui.pages.driver_commission_reports.table.No') }}
                                </th>
                                <th>
                                    <!-- 單號 -->
                                    {{ $t('ui.pages.driver_commission_reports.table.number') }}
                                </th>
                                <th>
                                    <!-- 重量 -->
                                    {{ $t('ui.pages.driver_commission_reports.table.weight') }}
                                </th>
                                <th>
                                    <!-- 日期 -->
                                    {{ $t('ui.pages.driver_commission_reports.table.date') }}
                                </th>
                                <th>
                                    <!-- 提成(元) -->
                                    {{ $t('ui.pages.driver_commission_reports.table.commission') }}
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(commission, index) in driver_commission_report.delivery_driver_commissions">
                                <td>{{ index+1 }}</td>
                                <td>{{ commission.core_waybill.number }}</td>
                                <td>{{ commission.core_waybill.weight_in_kilo }}</td>
                                <td>{{ human_datetime(commission.created_at) }}</td>
                                <td>{{ commission.amount }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                                <tr>
                                    <th colspan="4" class="center aligned">
                                        {{ $t('ui.pages.driver_commission_reports.table.total') }}
                                    </th>
                                    <th>{{ total_amount(driver_commission_report.delivery_driver_commissions) }}</th>
                                </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    name: "ShowDriverCommissionReport",
    props: {
    },
    data() {
        return {
            is_initialized: false,
            is_processing: false,
            driver_commission_report: {},
            errors: [],
        }
    },
    created() {

        this.init()
    },
    mounted() {

    },
    watch: {
        '$route' (to, from) {
            if (to.name == "edit_driver_commission_report") {
                this.init()
            }
        },
    },
    computed: {
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                this.is_processing = false
                this.driver_commission_report = {}
                this.errors = []
                resolve()
            })
            await this.fetch_driver_commission_report()
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        fetch_driver_commission_report() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_driver_commission_report).parse(
                {
                    "driver_commission_report_identity": this.$route.params.identity
                },
                ""
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    this.driver_commission_report = response.data.driver_commission_report
                    return Promise.resolve()
                })
                .catch(error => {
                    console.log('Failed to fetch driver_commission_report.')
                })
        },
        total_amount(commissions) {
            return _.sumBy(commissions, commission => {
                return parseInt(commission.amount)
            })
        }
    },
    components: {
    }
}
</script>

<style scoped>
</style>
